module.exports = __webpack_public_path__ + "img/plus.5c7f928c.svg";